module.exports = __webpack_public_path__ + "img/doublelayout.e9f80299.svg";